import React, { useState } from "react";
import { FaUserPlus, FaChalkboardTeacher, FaTimes, FaRocket } from "react-icons/fa";
import "../css/FloatingMenu.css";

// Import your tab-specific images here
import diagnosticImg from "../../images/service1.png";
import lmsImg from "../../images/service2.png";
import schoolImg from "../../images/service3.png";
import instituteImg from "../../images/service4.png";
import admissionImg from "../../images/service5.png";
import forumImg from "../../images/service6.png";
import kirnavaliImg from "../../images/kirnavaliicon.png";

function FloatingMenuKirnavali() {
    const [modalOpen, setModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    // State to control the "Coming Soon" popup modal visibility
    const [showComingSoonModal, setShowComingSoonModal] = useState(false);

    const handleKirnavaliLinkClick = (e) => {
        e.preventDefault();
        // Close the services modal first, then open the coming soon modal
        setModalOpen(false);
        setShowComingSoonModal(true);
    };

    const handleCloseComingSoonModal = () => {
        setShowComingSoonModal(false);
    };

    // Tab configuration with unique images per tab
    const serviceTabs = [
        {
            name: "Free Diagnostic Test",
            image: diagnosticImg,
            pointers: [
                "Free chapter-wise practice tests & concept maps",
                "AI-generated performance insights & report card",
                "Strength & weakness analysis with study plan",
                "Time, accuracy & chapter-wise progress tracking"
            ],
            linkText: "Start Free Diagnostic Test",
            linkUrl: "https://lms.crestest.com/page-login"
        },
        {
            name: "Complete CBSE Curriculum Mastery",
            image: lmsImg,
            pointers: [
                "Unlimited premium chapter-wise & full-length tests",
                "AI-powered analytics with personalized study plans",
                "Adaptive question engine & weak area detection",
                "Exam-ready simulations with parent growth insights"
            ],
            linkText: "Explore Premium Learning",
            linkUrl: "https://lms.crestest.com/page-login"
        },
        {
            name: "School Management",
            image: schoolImg,
            pointers: [
                "Digital admission & enrollment workflow",
                "Learning management, assignments & online exams",
                "Student performance analytics & AI-ready report cards",
                "Role-based administration with enterprise security"
            ],
            linkText: "Explore School ERP",
            linkUrl: "https://school.crestest.com"
        },
        {
            name: "Institute Management",
            image: instituteImg,
            pointers: [
                "Smart admission pipeline & document management",
                "Lecture hosting, LMS & assignment automation",
                "Online exams with proctoring & instant evaluation",
                "Analytics, audit trails & role-based administration"
            ],
            linkText: "Explore Institute ERP",
            linkUrl: "https://software.crestest.com"
        },
        {
            name: "Admission Management",
            image: admissionImg,
            pointers: [
                "Smart lead capture & digital admission forms",
                "Secure document verification & interview scheduling",
                "Real-time application tracking & fee collection",
                "Instant receipts with automated payment reconciliation"
            ],
            linkText: "Manage Admissions",
            linkUrl: "https://software.crestest.com"
        },
        {
            name: "Forum",
            image: forumImg,
            pointers: [
                "Create public & private posts with discussions",
                "Like, comment, share & connect with learners",
                "Community quizzes, leaderboards & badges",
                "Notifications, moderation & hashtag discovery"
            ],
            linkText: "Join Scholars' Forum",
            linkUrl: "https://forum.crestest.com/"
        },
        {
            name: "Kirnavali",
            title: "Kirnavali National Challenge Portal",
            image: kirnavaliImg,
            pointers: [
                "Nationwide academic challenges and competitions",
                "Comprehensive performance analysis and insights",
                "Skill-based testing to measure true growth",
                "Competitive leaderboards and national rankings"
            ],
            linkText: "Join National Challenge",
            linkUrl: "https://forum.crestest.com/"
        }
    ];

    // Helper function to determine which handler to use
    const handleLinkAction = (tabIndex, e) => {
        if (serviceTabs[tabIndex].name === "Kirnavali") {
            handleKirnavaliLinkClick(e);
        } else {
            // For other tabs, open the link in a new tab
            window.open(serviceTabs[tabIndex].linkUrl, '_blank');
        }
    };

    return (
        <>
            <div className="crest-floater-container">
                <a
                    href="https://kirnavali.crestestlearning.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="crest-floater-btn floater-blue"
                    title="Register Here"
                >
                    <FaUserPlus className="floater-icon" />
                    <span className="floater-label"></span>
                </a>

                <button
                    type="button"
                    onClick={() => setModalOpen(true)}
                    className="crest-floater-btn floater-yellow border-0"
                    title="Teacher & Services"
                >
                    <FaChalkboardTeacher className="floater-icon" />
                    <span className="floater-label"></span>
                </button>
            </div>

            {modalOpen && (
                <div className="crest-modal-backdrop">
                    <div className="crest-modal-card glass-morphic-modal">

                        <button
                            className="crest-modal-close"
                            onClick={() => setModalOpen(false)}
                        >
                            <FaTimes />
                        </button>

                        <div className="crest-modal-header-group text-center">
                            <p className="modal-small-txt">Explore Our Ecosystem</p>
                            <h2 className="modal-heading-txt">Comprehensive Learning & Management Solutions</h2>
                            <p className="modal-sub-txt">
                                Empowering students, educators, and institutions with cutting-edge digital infrastructure designed for academic excellence.
                            </p>
                        </div>

                        <div className="crest-modal-tabs-container">
                            {serviceTabs.map((tab, index) => (
                                <button
                                    key={index}
                                    className={`crest-modal-tab-btn ${activeTab === index ? 'active-tab' : ''}`}
                                    onClick={() => setActiveTab(index)}
                                >
                                    {tab.name}
                                </button>
                            ))}
                        </div>

                        <div className="crest-modal-body-split">

                            <div className="modal-split-left">
                                <h4 className="split-section-title">Key Capabilities</h4>
                                <ul className="modal-pointers-list">
                                    {serviceTabs[activeTab].pointers.map((pointer, i) => (
                                        <li key={i} className="pointer-item">
                                            <span className="pointer-bullet">✓</span> {pointer}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Right Part: Dynamic Image per Tab + Conditional Action Button */}
                            <div className="modal-split-right">
                                <div className="modal-image-wrapper">
                                    <img
                                        src={serviceTabs[activeTab].image}
                                        alt={serviceTabs[activeTab].name}
                                        className="img-fluid modal-preview-img"
                                    />
                                </div>
                                <button
                                    onClick={(e) => handleLinkAction(activeTab, e)}
                                    className="btn crest-goto-btn"
                                >
                                    {serviceTabs[activeTab].linkText} →
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            )}

            {/* Coming Soon Modal */}
            {showComingSoonModal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content shadow-lg border-0 rounded-4 text-center p-4">
                            
                            <div className="modal-header border-0 pb-0 justify-content-end">
                                <button type="button" className="btn-close" onClick={handleCloseComingSoonModal}></button>
                            </div>

                            <div className="modal-body px-3 py-2">
                                <div className="mb-3 text-primary" style={{ fontSize: '42px' }}>
                                    <FaRocket />
                                </div>
                                <h4 className="fw-bold mb-3" style={{ color: '#207AB4' }}>Coming Soon!</h4>
                                <p className="text-muted mb-4">
                                    The <strong>Kirnavali National Challenge Portal</strong> is currently under development and will be launching shortly. Stay tuned for exciting academic challenges!
                                </p>
                                <button 
                                    type="button" 
                                    className="btn px-4 py-2 rounded-pill fw-bold" 
                                    style={{ backgroundColor: '#FBBB1B', color: '#1e293b' }}
                                    onClick={handleCloseComingSoonModal}
                                >
                                    Got It
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default FloatingMenuKirnavali;